import { createApp } from 'vue'
import './style.css'
import App from './App.vue'
import { createWebHistory, createRouter } from 'vue-router'
import { initWatchdog, WatchdogVuePlugin } from '@9apes/rum-sdk'
import { datadogRum } from "@datadog/browser-rum";
import posthog from 'posthog-js';
import mixpanel from "mixpanel-browser";
import LogRocket from 'logrocket';

const userId = Math.floor(Math.random() * 10) + 1;

// A/B Test: Randomly assign users to either Watchdog (Group A) or Datadog (Group B)
// Can be overridden via query param: ?monitoring=watchdog|datadog|mixpanel|posthog
const urlParams = new URLSearchParams(window.location.search);
const monitoringOverride = urlParams.get('monitoring') || 'watchdog';

let useWatchdog = false;

switch (monitoringOverride) {
  case 'watchdog':
    console.log('A/B Test: User assigned to Watchdog');
    initWatchdog({
      userId: userId.toString(),
      apiKey: '9aps_99451fdf957f7ddfd7a61b9c5cfbe3fbd7f18f905e897a1c',
      env: 'prod',
    });
    useWatchdog = true;
    break;

  case 'datadog':
    console.log('A/B Test: User assigned to Datadog');
    datadogRum.init({
      applicationId: 'd11c4d35-d055-4956-8748-d8222536ee8b',
      clientToken: 'pub7a78adbc888341552e9a55fe49b845c0',
      site: 'datadoghq.com',
      service: 'rum',
      env: 'production',
      sessionSampleRate: 100,
      sessionReplaySampleRate: 20,
      trackBfcacheViews: true,
      defaultPrivacyLevel: 'mask-user-input',
    });
    break;

  case 'mixpanel':
    mixpanel.init('27c1f80c44b6ea20bff1618f0389faac', {
      autocapture: true,
      record_sessions_percent: 20,
    });
    break;

  case 'posthog':
    posthog.init('phc_UgIYtgi2v1gU32r8Aen1p30eCe6Q7PkQiNrQXFngznw', {
      api_host: 'https://us.i.posthog.com',
      defaults: '2025-11-30'
    });
    break;
  
  case 'logrocket':
    LogRocket.init('m5sb6n/pokedex');
    break;

  default:
    console.log('A/B Test: User assigned to Watchdog');
    initWatchdog({
      userId: userId.toString(),
      apiKey: '9aps_99451fdf957f7ddfd7a61b9c5cfbe3fbd7f18f905e897a1c',
      env: 'prod',
    });
    useWatchdog = true;
    break;
}


const HomeView = () => import('./views/HomeView.vue')
const PokemonView = () => import('./views/PokemonView.vue')
const AboutView = () => import('./views/AboutView.vue')
const AboutPokemonView = () => import('./views/AboutPokemonView.vue')
const ErrorTestView = () => import('./views/ErrorTestView.vue')
const PokeballsView = () => import('./views/PokeballsView.vue')


const routes = [
    { path: '/', component: HomeView },
    { path: '/pokemon/:id', component: PokemonView },
    { path: '/about', component: AboutView },
    { path: '/about-pokemon', component: AboutPokemonView },
    { path: '/error-test', component: ErrorTestView },
    { path: '/pokeballs', component: PokeballsView }
  ]

const router = createRouter({
  history: createWebHistory(),
  routes
})

const app = createApp(App)

// Only install Watchdog Vue plugin for users in the Watchdog group
if (useWatchdog) {
  // Install Watchdog Vue plugin to automatically capture Vue errors
  // logToConsole defaults to false to avoid duplicate console errors
  app.use(WatchdogVuePlugin, {
    logToConsole: false // Set to true for debugging if needed
  })
}

app.use(router).mount('#app')
